import Common from "./common.js";
import "../../scss/v5/streaming.scss";

import BottomSheet from "./components/BottomSheet.js";
import SettingsForm from "./components/SettingsForm.js";
import ExpandableMovie from "./components/ExpandableMovie.js";
import LoadingMovies from "./components/LoadingMovies.js";
import MonthNavigator from "./components/MonthNavigator.js";

Common.initPage(async () => {
  let streamingFilterSettingsForm;

  const streamingFilterBottomSheet = BottomSheet(document.querySelector("#streaming-filters"), {
    componentName: "StreamingFilterBottomSheet",
    onOpen: async () => {
      streamingFilterSettingsForm = SettingsForm(document.querySelector("#streaming-filter-form"), {
        onSubmit: (event) => {
          event.preventDefault();
          const year = event.target.year.value;
          const genre = event.target.genre.value;
          const country = event.target.country.value;
          const type = event.target.type.value;
          const provider = event.target.provider.value;

          // Build URL: /streaming/[year]/[genre]?country=...&type=...&provider=...
          let url = "/streaming/" + year + "/";

          // Add genre to path
          if (genre) {
            url += genre;
          }

          const params = [];

          // Add country to query params
          if (country) {
            params.push("country=" + encodeURIComponent(country));
          }

          if (type) {
            params.push("type=" + encodeURIComponent(type));
          }
          if (provider) {
            params.push("provider=" + encodeURIComponent(provider));
          }

          if (params.length > 0) {
            url += "?" + params.join("&");
          }

          window.location = url;
        },
      }).mount();
    },
    onClose: async () => {
      if (streamingFilterSettingsForm) {
        streamingFilterSettingsForm.unmount();
      }
    },
  }).mount();

  document.querySelectorAll("[data-open='streaming-filters']").forEach((element) => {
    element.addEventListener("click", () => {
      streamingFilterBottomSheet.open();
    });
  });

  const headerHeight = document.querySelector("header#header")?.offsetHeight || 0;
  document.querySelectorAll(".item-list.movie-list > li > a").forEach((item) => {
    ExpandableMovie(item, { scrollOffset: headerHeight }).render();
  });

  LoadingMovies({
    loadingSections: Array.from(document.querySelectorAll(".streaming-movies.loading")),
  }).render();

  const streamingMonthsLinks = document.querySelectorAll(".streaming-months > li > a");
  if (streamingMonthsLinks.length > 0) {
    MonthNavigator({
      yearMonthsLinks: Array.from(streamingMonthsLinks),
      sectionSelector: "section.item-list-section.streaming-movies",
    }).render();
  }
});
